export default function AtsGauge({ score = 0, size = 160, label = "ATS MATCH" }) {
  const radius = size / 2 - 12;
  const circ = 2 * Math.PI * radius;
  const pct = Math.max(0, Math.min(100, score));
  const offset = circ - (pct / 100) * circ;
  const color = pct >= 75 ? "rgb(var(--gi-brand))" : pct >= 50 ? "rgb(var(--gi-warning))" : "rgb(var(--gi-danger))";

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid="ats-score-gauge">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="rgb(var(--gi-line))" strokeWidth="10" fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth="10"
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 1s ease" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-display text-4xl font-extrabold" style={{ color }}>{pct}<span className="text-lg text-faint">%</span></span>
        <span className="font-mono2 text-xs uppercase tracking-widest text-faint mt-1">{label}</span>
      </div>
    </div>
  );
}
